import {useQuery} from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import {PlayerClubsResponse} from './types';

// GET /players/<username>/clubs/ -- IsAuthenticated, open to any logged-in
// viewer (owner or visitor), not owner-only -- same as Games.
export const useGetPlayerClubsApi = (username?: string) =>
  useQuery(
    ['playerClubs', username],
    async (): Promise<PlayerClubsResponse> =>
      (await ChessRestClient.get(`/players/${username}/clubs/`)).data,
    {enabled: !!username},
  );

export default useGetPlayerClubsApi;
